import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Statistic, List, Tag } from 'antd';
import {
  ShoppingOutlined,
  AppstoreOutlined,
  PictureOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { productApi, batchApi } from '../../services/api';
import dayjs from 'dayjs';

const Dashboard = () => {
  const [stats, setStats] = useState({
    productCount: 0,
    batchCount: 0,
    photoCount: 0
  });
  const [recentProducts, setRecentProducts] = useState([]);
  const [recentBatches, setRecentBatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [productsRes, batchesRes] = await Promise.all([
        productApi.list({ page: 1, limit: 5 }),
        batchApi.list({ page: 1, limit: 5 })
      ]);

      setStats({
        productCount: productsRes.data.pagination.total,
        batchCount: batchesRes.data.pagination.total,
        photoCount: productsRes.data.list.reduce((sum, p) => sum + (p.photo_count || 0), 0) +
                    batchesRes.data.list.reduce((sum, b) => sum + (b.photo_count || 0), 0)
      });

      setRecentProducts(productsRes.data.list);
      setRecentBatches(batchesRes.data.list);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>数据概览</h2>
      
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={8}>
          <Card loading={loading}>
            <Statistic
              title="货品总数"
              value={stats.productCount}
              prefix={<ShoppingOutlined />}
              valueStyle={{ color: '#8B7355' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card loading={loading}>
            <Statistic
              title="批次总数"
              value={stats.batchCount}
              prefix={<AppstoreOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={8}>
          <Card loading={loading}>
            <Statistic
              title="照片总数"
              value={stats.photoCount}
              prefix={<PictureOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} lg={12}>
          <Card
            title="最近添加的货品"
            loading={loading}
            extra={<a href="#/admin/products">查看全部</a>}
          >
            <List
              dataSource={recentProducts}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    title={item.name}
                    description={`编码: ${item.product_code}`}
                  />
                  <div>
                    <Tag color="default">{item.batch_no}</Tag>
                    <span style={{ color: '#999', fontSize: 12, marginLeft: 8 }}>
                      {dayjs(item.created_at).format('MM-DD')}
                    </span>
                  </div>
                </List.Item>
              )}
            />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card
            title="最近创建的批次"
            loading={loading}
            extra={<a href="#/admin/batches">查看全部</a>}
          >
            <List
              dataSource={recentBatches}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    title={item.name}
                    description={`编号: ${item.batch_no}`}
                  />
                  <div>
                    <Tag color="blue">{item.product_count} 件货品</Tag>
                    <span style={{ color: '#999', fontSize: 12, marginLeft: 8 }}>
                      {dayjs(item.created_at).format('MM-DD')}
                    </span>
                  </div>
                </List.Item>
              )}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
